module.exports = __webpack_public_path__ + "img/dz.233588e8.png";